import React from 'react';
import ReactDOM from 'react-dom';
import { ExperienceProvider, ContextBuilder } from '@thd-nucleus/experience-context';
import { initIndexDB } from '@thd-olt-global/thd-storage-utils';
import { App } from './App';

const indexDBConfig = {
  version: 2,
  stores: {
    sessions: {
      storeConfig: { keyPath: 'sessionId' },
      indexes: [{ name: 'sessionId', unique: true }],
    },
    messages: {
      storeConfig: { keyPath: 'id', autoIncrement: true },
      indexes: [{ name: 'id', unique: true }],
    }
  }
};

initIndexDB('assistantBotDB', indexDBConfig).catch(() => {});
const { experienceContext } = ContextBuilder.client({
  expConfiguration: window?.__EXPERIENCE_PROPS__?.expConfiguration
});

ReactDOM.render(
  <React.StrictMode>
    <ExperienceProvider value={experienceContext}>
      <App />
    </ExperienceProvider>
  </React.StrictMode>,
  document.getElementById('magic-apron-loader')
);
